import React from "react"
import styled from "@emotion/styled"

import Layout from "../components/layout"
import Sample from "../components/sample"

const Grid = styled.div`
    display: flex;
`

const Col = styled.div`
    width: 50%;
`

const Button = styled.a`
    font-size: 18px;
    padding: 14px;
    margin: 20px;
    color: white;
    background-color: #147dff;
    display: inline-block;
    text-decoration: none;
    border-radius: 6px;
    border: 2px solid #147dff;
    &:hover{
        background-color: white;
        color: #147dff;
    }
`

const IndexPage = () => (
  <Layout>
    <Sample fontSize="58px" fontWeight="600" lineHeight="1.4">A typeface I have yet to name.<br /> <span style={{ fontWeight: 'normal' }}>Prehaps ‘Tui Sans’.</span> </Sample>

    <div>
        <Button href='Tui-Sans.zip'>Download version 1.1 ⬇️</Button>
    </div>

    <Grid>
        <Col>
            <Sample fontSize="16px" fontWeight="400" lineHeight="1.5">
            Also, in J. R. R. Tolkien’s The Lord of the Rings, the character of Gollum may be considered to have both disgusting and empathetic qualities, which fit him into the grotesque template. Victor Hugo’s Hunchback of Notre Dame is one of the most celebrated grotesques in literature. Dr. Frankenstein’s monster can also be considered a grotesque, as well as the title character, Erik in The Phantom of the Opera and the Beast in Beauty and the Beast.
            </Sample>
        </Col>
        <Col>
            <Sample fontSize="16px" fontWeight="400" lineHeight="1.5">
            Other instances of the romantic grotesque are also to be found in Edgar Allan Poe, E.T.A. Hoffmann, in Sturm und Drang literature or in Sterne’s Tristram Shandy. The romantic grotesque is far more terrible and sombre than the medieval grotesque, which celebrated laughter and fertility. It is at this point that a grotesque creature such as Frankenstein’s monster (in Mary Shelley’s novel published in 1818) begins to be presented more sympathetically.
            </Sample>
        </Col>
    </Grid>

    <Grid>
        <Col>
            <Sample fontSize="14px" fontWeight="400" lineHeight="1.5">
            Also, in J. R. R. Tolkien’s The Lord of the Rings, the character of Gollum may be considered to have both disgusting and empathetic qualities, which fit him into the grotesque template. Victor Hugo’s Hunchback of Notre Dame is one of the most celebrated grotesques in literature. Dr. Frankenstein’s monster can also be considered a grotesque, as well as the title character, Erik in The Phantom of the Opera and the Beast in Beauty and the Beast.
            </Sample>
        </Col>
        <Col>
            <Sample fontSize="12px" fontWeight="400" lineHeight="1.5">
            Other instances of the romantic grotesque are also to be found in Edgar Allan Poe, E.T.A. Hoffmann, in Sturm und Drang literature or in Sterne’s Tristram Shandy. The romantic grotesque is far more terrible and sombre than the medieval grotesque, which celebrated laughter and fertility. It is at this point that a grotesque creature such as Frankenstein’s monster (in Mary Shelley’s novel published in 1818) begins to be presented more sympathetically.
            </Sample>
        </Col>
    </Grid>

    <Sample fontSize="58px" fontWeight="600">Tēnā koe</Sample>

    <Sample fontSize="24px" fontWeight="400" lineHeight="1.5">
        Kōwhiria te momo kete e hiahia ana koe ki te hanga, ka whakaingoa ai i te kete me te tāuru i ō ihirangi i mua i te pāwhiri Tiaki. I tipu ake he rakahinonga hou – ngā kaihanga kiriata, ngā kaihanga pūmanawa rorohiko, ngā kaikōpiro waipiro, ngā kaitunu kai me ngā.
    </Sample>

    
    <Sample fontSize="42px" fontWeight="400">On top of their roofs grow slender stalks and volutes with human figures senselessly seated upon them.</Sample>
    <Sample fontSize="42px" fontWeight="500">They were introduced by Raphael Sanzio and his team of decorative painters.</Sample>
    <Sample fontSize="42px" fontWeight="600">Other 16th-century writers on grottesche included Daniele Barbaro, Pirro Ligorio and Gian Paolo Lomazzo.</Sample>
    <Sample fontSize="42px" fontWeight="700">This large array provided a repertoire of elements that were the basis for later artists across Europe.</Sample>
    <Sample fontSize="42px" fontWeight="800">Such designs were fashionable in ancient Rome, as fresco wall decoration, floor mosaics, etc.</Sample>
    <Sample fontSize="42px" fontWeight="900">Dismissing them as meaningless and illogical, part of the series of Raphael’s Rooms in the Vatican Palace, Rome.</Sample>

    <Sample fontSize="108px" fontWeight="400">
        AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz0123456789
    </Sample>

    <Sample fontSize="108px" fontWeight="700">
        AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz0123456789
    </Sample>

    <Sample fontSize="108px" fontWeight="900">
        AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz0123456789
    </Sample>

    <Grid>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="400">a</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="500">a</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="600">a</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="700">a</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="800">a</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="900">a</Sample></Col>
    </Grid>

    <Grid>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="400">b</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="500">b</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="600">b</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="700">b</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="800">b</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="900">b</Sample></Col>
    </Grid>

    <Grid>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="400">u</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="500">u</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="600">u</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="700">u</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="800">u</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="900">u</Sample></Col>
    </Grid>

    <Grid>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="400">s</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="500">s</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="600">s</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="700">s</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="800">s</Sample></Col>
        <Col><Sample fontSize="140px" lineHeight="1" fontWeight="900">s</Sample></Col>
    </Grid>

    <Sample fontSize="18px" fontWeight="400">Made by Eliot Slevin</Sample>


</Layout>
)

export default IndexPage